import { ORDER_SKU, VENDOR_ID } from 'core-lib/config/Env';

export enum Source {
  CarWash = 'CarWash',
  CarWashTipping = 'CarWashTipping',
  CarSpaRescheduleFee = 'CarSpaRescheduleFee',
  CarCareFullSpa = 'CarCareFullSpa',
  CarCareExterior = 'CarCareExterior',
  CarCareInterior = 'CarCareInterior',
  CarCareInteriorOnly = 'CarCareInteriorOnly',
  CarWax = 'CarWax',
  Challan = 'Challan',
  Valet = 'Valet',
  Parking = 'Parking',
  ExtendedParking = 'ExtendedParking',
  FastagRecharge = 'FastagRecharge',
  FastagPurchase = 'FastagPurchase',
  ParkingExit = 'ParkingExit',
  ParkPlusGo = 'ParkPlusGo',
  CarCare = 'CarCare',
  Wallet = 'Wallet',
  TagPayment = 'TagPayment',
  Tyres = 'Tyres',
  SocietyHome = 'SocietyHome',
  ValetNew = 'ValetNew',
  ParkplusStore = 'ParkplusStore',
  DonationDrive = 'DonationDrive',
  Vouchers = 'Vouchers',
  DriverSalary = 'DriverSalary',
  UcdSubscription = 'UcdSubscription',
  HomeInsurance = 'HomeInsurance',
  IncomeProtect = 'IncomeProtect',
  SMAS = 'SMAS',
  IOCL = 'IOCL',
  PayPlus = 'PayPlus',
  PickAndDrop = 'PickAndDrop',
  FuelBillUpload = 'FuelBillUpload',
  InvoicePayment = 'InvoicePayment',
  DealerAddMoneyToWallet = 'DealerAddMoneyToWallet',
  CstTagReplacement = 'CstTagReplacement',
  BillPayment = 'BillPayment',
  CarSell = 'car_sell',
  VehicleVerification = 'VehicleVerification',
  MlStore = 'MlStore',
  MasterAddon = 'MasterAddon',
  RoadAssistance = 'RoadAssistance',
  SocietyReactivation = 'SocietyReactivation',
  RcTransfer = 'RcTransfer',
  DriverOnDemand = 'DriverOnDemand',
  CarInsurance = 'CarInsurance',
  VehicleVerificationB2C = 'VehicleVerificationB2C',
  FastagProIndependent = 'FastagProIndependent',
  TagFee = 'TagFee',
  RsaToa = 'RsaToa',
  PreDeliveryInspection = 'PreDeliveryInspection',
  TataExpressTestDrive = 'TATA_EXPRESS_TEST_DRIVE_2025',
  SocietyVms = 'SocietyVms',
}

export const VENDOR_ID_SKU: {
  [key: string]: {
    vendorId: string | number | null;
    sku: string | number | null;
  };
} = {
  [Source.CarWash]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.carWash,
    // @ts-ignore
    sku: ORDER_SKU.carWash,
  },
  [Source.CarWashTipping]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.carWashTipping,
    // @ts-ignore
    sku: ORDER_SKU.carWashTipping,
  },
  [Source.CarSpaRescheduleFee]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.carSpaRescheduleFee,
    // @ts-ignore
    sku: ORDER_SKU.carSpaRescheduleFee,
  },
  [Source.CarCareFullSpa]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.carCareFullSpa,
    // @ts-ignore
    sku: ORDER_SKU.carCareFullSpa,
  },
  [Source.CarCareExterior]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.carCareExterior,
    // @ts-ignore
    sku: ORDER_SKU.carCareExterior,
  },
  [Source.CarCareInterior]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.carCareInterior,
    // @ts-ignore
    sku: ORDER_SKU.carCareInterior,
  },
  [Source.CarCareInteriorOnly]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.carCareInteriorOnly,
    // @ts-ignore
    sku: ORDER_SKU.carCareInteriorOnly,
  },
  [Source.CarWax]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.carWash,
    // @ts-ignore
    sku: ORDER_SKU.carWash,
  },
  [Source.Challan]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.challan,
    // @ts-ignore
    sku: ORDER_SKU.challan,
  },
  [Source.Valet]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.valet,
    // @ts-ignore
    sku: ORDER_SKU.valet,
  },
  [Source.ValetNew]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.valetNew,
    // @ts-ignore
    sku: ORDER_SKU.valetNew,
  },
  [Source.Parking]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.parking,
    // @ts-ignore
    sku: ORDER_SKU.parking,
  },
  [Source.ExtendedParking]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.extendParking,
    // @ts-ignore
    sku: ORDER_SKU.extendParking,
  },
  [Source.IOCL]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.iocl,
    // @ts-ignore
    sku: ORDER_SKU.iocl,
  },
  [Source.FastagRecharge]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.rechargeFastag,
    // vendorId: +VENDOR_ID.carWash,
    // @ts-ignore
    sku: ORDER_SKU.fastagRecharge,
    // sku: ORDER_SKU.carWash,
  },
  [Source.FastagPurchase]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.buyFastag,
    // @ts-ignore
    sku: ORDER_SKU.fastag,
  },
  [Source.ParkingExit]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.carWash,
    // @ts-ignore
    sku: ORDER_SKU.carWash,
  },
  [Source.ParkPlusGo]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.parkPlusGo,
    // @ts-ignore
    // TODO: Check about this
    sku: ORDER_SKU.parkPlusGo,
  },
  [Source.Wallet]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.wallet,
    // @ts-ignore
    sku: ORDER_SKU.wallet,
  },
  [Source.CarCare]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.carCare,
    // @ts-ignore
    sku: '',
  },
  [Source.TagPayment]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.tagPayment,
    // @ts-ignore
    sku: '',
  },
  [Source.Tyres]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.tyres,
    // @ts-ignore
    sku: '',
  },
  [Source.SocietyHome]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.tagPayment,
    sku: '',
  },

  [Source.ParkplusStore]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.parkplusStore,
    sku: '',
  },
  [Source.MlStore]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.mlStore,
    sku: '',
  },
  [Source.DonationDrive]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.donationDrive,
    sku: '',
  },
  [Source.UcdSubscription]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.ucdSubscription,
    sku: '',
  },
  [Source.DriverSalary]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.driverSalary,
    // @ts-ignore
    sku: ORDER_SKU.paymentUtils,
  },
  [Source.HomeInsurance]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.homeInsurance,
    // @ts-ignore
    sku: ORDER_SKU.homeInsurance,
  },
  [Source.Vouchers]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.vouchers,
    // @ts-ignore
    sku: ORDER_SKU.vouchers,
  },
  [Source.IncomeProtect]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.incomeProtect,
    // @ts-ignore
    sku: ORDER_SKU.incomeProtect,
  },
  [Source.SMAS]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.incomeProtect,
    // @ts-ignore
    sku: ORDER_SKU.incomeProtect,
  },
  [Source.PayPlus]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.payPlus,
    // @ts-ignore
    sku: ORDER_SKU.payPlus,
  },
  [Source.PickAndDrop]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.pickAndDrop,
    // @ts-ignore
    sku: ORDER_SKU.pickAndDrop,
  },
  [Source.FuelBillUpload]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.fuelBillUpload,
    // @ts-ignore
    sku: ORDER_SKU.fuelBillUpload,
  },
  [Source.InvoicePayment]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.invoicePayment,
    // @ts-ignore
    sku: ORDER_SKU.invoicePayment,
  },
  [Source.DealerAddMoneyToWallet]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.dealerAddWallet,
    // @ts-ignore
    sku: ORDER_SKU.dealerAddWallet,
  },
  [Source.CstTagReplacement]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.cstTagReplacement,
    // @ts-ignore
    sku: ORDER_SKU.cstTagReplacement,
  },
  [Source.BillPayment]: {
    //@ts-ignore
    vendorId: +VENDOR_ID.billPayment,
    sku: '',
  },
  [Source.VehicleVerification]: {
    //@ts-ignore
    vendorId: +VENDOR_ID.vehicleVerification,
    //@ts-ignore
    sku: ORDER_SKU.vehicleVerification,
  },
  [Source.MasterAddon]: {
    vendorId: +VENDOR_ID.masterAddon,
    sku: '',
  },
  [Source.RoadAssistance]: {
    vendorId: +VENDOR_ID.roadAssistance,
    sku: ORDER_SKU.roadAssistance,
  },
  [Source.SocietyReactivation]: {
    vendorId: +VENDOR_ID.societyReactivation,
    sku: ORDER_SKU.societyReactivation,
  },
  [Source.RcTransfer]: {
    vendorId: +VENDOR_ID.rcTransfer,
    sku: ORDER_SKU.rcTransfer,
  },
  [Source.DriverOnDemand]: {
    vendorId: +VENDOR_ID.driverOnDemand,
    sku: ORDER_SKU.driverOnDemand,
  },
  [Source.CarInsurance]: {
    vendorId: +VENDOR_ID.CarInsurance,
    sku: '',
  },
  [Source.VehicleVerificationB2C]: {
    vendorId: +VENDOR_ID.VehicleVerificationB2C,
    sku: ORDER_SKU.VehicleVerificationB2C,
  },
  [Source.FastagProIndependent]: {
    vendorId: +VENDOR_ID.rechargeFastag,
    sku: ORDER_SKU.fastagProIndependent,
  },
  [Source.TagFee]: {
    vendorId: +VENDOR_ID.TagFee,
    sku: ORDER_SKU.tagFee,
  },
  [Source.RsaToa]: {
    vendorId: +VENDOR_ID.RsaToa,
    sku: ORDER_SKU.rsaToa,
  },
  [Source.PreDeliveryInspection]: {
    vendorId: +VENDOR_ID.preDeliveryInspection,
    sku: ORDER_SKU.preDeliveryInspection,
  },
  [Source.SocietyVms]: {
    // @ts-ignore
    vendorId: +VENDOR_ID.societyVms,
    sku: '',
  },
};
